"use client";
import { useEffect } from "react";
const Loader = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <div>      
      <div className="custom-loader-bg">
      <div className="custom-loader"/>
    </div>
    </div>
  );
};

export default Loader;
